export enum EBalanceRenewalPeriod {
  MONTHLY = 1,
  QUARTERLY,
  YEARLY,
  NON_RENEWABLE,
}

export enum EPlanType {
  TRIAL = 1,
  STANDARD,
  CUSTOM,
  CORPORATE,
  PAY_AS_YOU_GO,
}

export enum EOrganizationPlanStatus {
  ACTIVE = 1,
  CANCELLED,
  EXPIRED,
  SUSPENDED,
  DELETED,
}

export enum EPlanName {
  Trial = 'trial',
  Starter = 'starter',
  Professional = 'professional',
  Business = 'business',
  Corporate = 'corporate',
}

export const PLAN_FEATURES = {
  [EPlanName.Trial]: [
    { id: 1, featureTranslationRef: 'Platform Users for only 1 user' },
    { id: 2, featureTranslationRef: '100 e-mails' },
    { id: 3, featureTranslationRef: 'Unlimited campaign templates' },
    { id: 4, featureTranslationRef: '1 automation flow' },
    { id: 5, featureTranslationRef: 'E-mail support' },
  ],
  [EPlanName.Starter]: [
    { id: 1, featureTranslationRef: 'Platform Users for only 1 user' },
    { id: 2, featureTranslationRef: '2000 e-mails/month' },
    { id: 3, featureTranslationRef: '3 campaign templates' },
    { id: 4, featureTranslationRef: '1 automation flow' },
    { id: 5, featureTranslationRef: 'E-mail support' },
  ],
  [EPlanName.Professional]: [
    { id: 1, featureTranslationRef: 'Platform Users up to 3 users' },
    { id: 2, featureTranslationRef: '2000 e-mails/month' },
    { id: 3, featureTranslationRef: '10 campaign templates' },
    { id: 4, featureTranslationRef: '5 automation flow' },
    { id: 5, featureTranslationRef: 'E-mail support' },
    { id: 6, featureTranslationRef: 'HTML Template import' },
    { id: 7, featureTranslationRef: 'Phone Support' },
  ],
  [EPlanName.Business]: [
    { id: 1, featureTranslationRef: 'Platform Users up to 3 users' },
    { id: 2, featureTranslationRef: '2000 e-mails/month' },
    { id: 3, featureTranslationRef: '10 campaign templates' },
    { id: 4, featureTranslationRef: '5 automation flow' },
    { id: 5, featureTranslationRef: 'E-mail support' },
    { id: 6, featureTranslationRef: 'HTML Template import' },
    { id: 7, featureTranslationRef: 'Phone Support' },
    { id: 8, featureTranslationRef: 'Template Premium' },
  ],
  [EPlanName.Corporate]: [
    {
      id: 1,
      featureTranslationRef:
        'Please consult your contract or contact your Account Manager',
    },
  ],
}
